import { omit } from "lodash-es";
import { fetchAuthor } from "../../fetch/graphql/requests/author";
import {
    set_author_profile,
    set_author_recent_content,
    reset_author,
} from "../../reducers/Author/reducer";
import { start_loading } from "../../reducers/Loader/reducer";
import { dispatchUpdateApp } from "../Detail/dispatchers";
import { set_loading_complete } from "../Loader/dispatchers";
import { transformAuthorContentList } from "../../utils/dataTransform/library";
import { GqlError } from "../../utils/errors/http";
import log from "../../utils/logger/library";

const DEFAULT_PAGE_SIZE = 10;

export const fetch_author = ({ contentId, page = 1 }) => {
    return async (dispatch, getState) => {
        const isFirstPage = page === 1;

        if (isFirstPage) {
            dispatch(reset_author());
        }
        const currentList = getState().author.recentContent?.list || [];
        try {
            dispatch(start_loading());
            const { author } = await fetchAuthor(contentId, page);

            const updatedAuthor = omit(author, ["recentContent"]);

            if (isFirstPage) {
                dispatch(set_author_profile(updatedAuthor));
                dispatch(
                    dispatchUpdateApp(
                        Object.assign({}, updatedAuthor, { type: "authorbio" })
                    )
                );
            }
            dispatch(
                set_author_recent_content({
                    list: currentList.concat(
                        transformAuthorContentList(author.recentContent.nodes)
                    ),
                    pageValue: page,
                    hasNextPage:
                        author.recentContent.nodes.length === DEFAULT_PAGE_SIZE,
                })
            );
        } catch (error) {
            const handledError =
                error instanceof Error ? error : new GqlError(error);
            log.error(
                `(fetch_author) request failed for ${contentId}`,
                handledError
            );
            if (isFirstPage) {
                throw handledError;
            } else {
                dispatch(
                    set_author_recent_content({
                        list: currentList,
                        pageValue: page - 1,
                        hasNextPage: false,
                    })
                );
            }
        } finally {
            dispatch(set_loading_complete());
        }
    };
};

export const fetch_author_load_more = (contentId) => {
    const constantProps = {
        contentId,
    };
    return (fetchProps) => fetch_author({ ...constantProps, ...fetchProps });
};
